import React, { useState, useEffect, useRef } from 'react'
import { Tooltip } from 'bootstrap'
import DOMPurify from 'dompurify'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import { postData } from '../../../../js/helpers/apiHelper'
import { useDispatch, useSelector } from 'react-redux'
import {
  setFleetVehicle,
  setSelectedVehicle,
  setStep,
} from '../../../../js/lib/redux/slices/booking'
import constants from '../../../../js/lib/constants'
import { Modal } from '@mui/material'
import isTransmissionAuto from '../../../../js/helpers/isTransmissionAuto'

const formatNumber = (number) =>
  Intl.NumberFormat('en', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(number)

const VehicleCard = ({
  grid = false,
  data,
  fleet,
  handleBooking,
  isLoading,
}) => {
  // const { selectedVehicle } = useSelector((state) => state.booking)
  // const dispatch = useDispatch()
  const { dictionary, records } =
    window.fleetData || window.bookingData || window.inpathData
  const brands = records.brands
  const {
    isGuaranteed,
    availability,
    modelImage,
    model,
    brandCode,
    similarText,
    passengers,
    luggage,
    sLuggage,
    availableCategories,
    ac,
    charging,
    prepaidPrice,
    nonPrepaidPrice,
    milesBonus,
    groupName,
    rateReference,
    acriss,
  } = data
  const hasTag = !fleet && (availability === 3 || isGuaranteed)

  const includesList =
    prepaidPrice?.total > 0 ? prepaidPrice?.includes : nonPrepaidPrice?.includes

  const paymentType =
    prepaidPrice?.total > 0 && nonPrepaidPrice?.total > 0
      ? 'both'
      : prepaidPrice?.total > 0
      ? 'prepaid'
      : 'nonPrepaid'

  const payNowSave =
    prepaidPrice?.symbol === nonPrepaidPrice?.symbol && paymentType === 'both'
      ? formatNumber(nonPrepaidPrice?.total - prepaidPrice.total)
      : null

  const brand = brands?.find((brand) => brand.brandCode === brandCode)
  const brandLogo = brand?.brandLogo

  const [showIncludesList, setShowIncludesList] = useState(false)
  const tooltipRef1 = useRef(null)
  const tooltipRef2 = useRef(null)
  // const [openFleetVehicleModal, setOpenFleetVehicleModal] = useState(false)

  useEffect(() => {
    const tooltips = []

    if (tooltipRef1.current) {
      tooltips.push(new Tooltip(tooltipRef1.current, { html: true }))
    }
    if (tooltipRef2.current) {
      tooltips.push(new Tooltip(tooltipRef2.current, { html: true }))
    }

    return () => {
      tooltips.forEach((tooltip) => tooltip.dispose())
    }
  }, [availability, isGuaranteed, fleet])

  // const onBooking = (isPrepaid) => {
  //   const vehicle = {
  //     groupName,
  //     rateReference,
  //     brandCode,
  //     isPrepaid,
  //     token,
  //     acriss,
  //   }
  //   if (fleet) {
  //     handleBooking(vehicle)
  //   } else {
  //     handleBooking(vehicle)
  //   }
  // }

  const milesBonusCondition =
    milesBonus && brand?.brandCode?.toLowerCase() === 'hertz'

  return (
    <>
      <div
        className={`b-vehicle-card ${grid ? 'b-vehicle-card--grid-view' : ''} ${
          fleet ? 'b-vehicle-card--fleet' : ''
        }`}>
        <div className="b-vehicle-card__main">
          {/* <!--left--> */}
          <div className="b-vehicle-card__info">
            {/* <!--DEV: render this if you have data--> */}
            {hasTag && (
              <div className="b-vehicle-card__tag">
                {!fleet && availability === 3 && isGuaranteed ? (
                  <div>
                    {dictionary.onRequestGuaranteedLabel}
                    <span
                      ref={tooltipRef1}
                      data-bs-toggle="tooltip"
                      data-bs-title={DOMPurify.sanitize(
                        dictionary.onRequestTooltipText
                      )}>
                      <i className="icon-info"></i>
                    </span>
                  </div>
                ) : !fleet && availability === 3 ? (
                  <div>
                    {dictionary.onRequestLabel}
                    <span
                      ref={tooltipRef2}
                      data-bs-toggle="tooltip"
                      data-bs-title={DOMPurify.sanitize(
                        dictionary.onRequestTooltipText
                      )}>
                      <i className="icon-info"></i>
                    </span>
                  </div>
                ) : !fleet && isGuaranteed ? (
                  dictionary.guaranteedLabel
                ) : null}
              </div>
            )}

            {!grid && (
              <div className="b-vehicle-card__img">
                <img src={modelImage} alt={model} />
              </div>
            )}
            <div className="b-vehicle-card__txt">
              <div className="b-vehicle-card__head">
                <div>
                  <div className="b-vehicle-card__brand">
                    {model}
                    <span>{similarText}</span>
                  </div>
                  {fleet && (
                    <div className="b-vehicle-card__brand pt-1">
                      <span>
                        {dictionary.group} {groupName}
                      </span>
                    </div>
                  )}
                </div>

                <div className="b-vehicle-card__logo">
                  {brandLogo && <img src={brandLogo} alt={brandCode} />}
                </div>
              </div>

              <div className="b-vehicle-card__details">
                <ul>
                  <li>
                    <div className="b-vehicle-card__details__passengers">
                      <i className="icon-passenger"></i>
                      {passengers} {dictionary.passengersLabel}
                    </div>
                  </li>
                  <li>
                    <div className="b-vehicle-card__details__suitcase">
                      <span className="large">
                        <i className="icon-suitcase"></i>x{luggage}
                      </span>
                      <span className="small">
                        <i className="icon-suitcase"></i>x{sLuggage}
                      </span>
                    </div>
                  </li>
                  <li>
                    <div className="b-vehicle-card__details__transmission">
                      <i className="icon-transmission"></i>
                      {isTransmissionAuto({ acriss })
                        ? dictionary.transmissionAutomatic
                        : dictionary.transmissionManual}
                    </div>
                  </li>
                  <li>
                    <div className="b-vehicle-card__details__acc">
                      <i className="icon-ac"></i>
                      {ac ? dictionary.acYes : dictionary.acNo}
                    </div>
                  </li>
                  {charging && (
                    <li>
                      <div className="b-vehicle-card__details__battery">
                        <i className="icon-battery-charging"></i>
                        {charging}
                      </div>
                    </li>
                  )}
                </ul>
              </div>

              {grid && (
                <div className="b-vehicle-card__img">
                  <img src={modelImage} alt={model} />
                </div>
              )}

              {!fleet && (
                <div className="b-vehicle-card__includes">
                  {/* <!--add class open next to b-dropdown--> */}
                  <div
                    className={`b-dropdown ${showIncludesList ? 'open' : ''}`}>
                    <button
                      type="button"
                      className="btn-clear b-dropdown__label"
                      onClick={() => setShowIncludesList((old) => !old)}
                      aria-expanded={showIncludesList}
                      aria-label={
                        showIncludesList ? 'Hide includes' : 'View includes'
                      }>
                      {showIncludesList
                        ? dictionary.hideIncludes
                        : dictionary.viewIncludes}
                      <i className="icon-arrow-dropdown-down"></i>
                    </button>
                    <div className="b-dropdown__body">
                      <ul>
                        {includesList?.map((item, index) => (
                          <li key={index}>
                            <i className="icon-check"></i>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {/* optional sections */}
              {!fleet && (
                <>
                  {milesBonusCondition && (
                    <div className="e-award-miles">
                      {dictionary.milesBonusText} | {milesBonus}
                    </div>
                  )}

                  {!milesBonusCondition && grid && (
                    <div className="e-award-miles e-award-miles--grey">
                      {dictionary.noMilesBonus}
                    </div>
                  )}
                  {(!milesBonusCondition || paymentType !== 'both') &&
                    !grid && (
                      <div className="b-vehicle-card__warnings">
                        <ul>
                          {!milesBonusCondition && (
                            <li>
                              <i className="icon-warning"></i>
                              {dictionary.noMilesBonus}
                            </li>
                          )}
                          {paymentType !== 'both' && (
                            <li>
                              <i className="icon-warning"></i>
                              {paymentType === 'prepaid'
                                ? dictionary.noPaymentOnLocation
                                : dictionary.noPrepaidAvailable}
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                </>
              )}

              {/* optional sections end*/}
            </div>
          </div>

          {/* <!--right--> */}
          {!fleet ? (
            <div className="b-vehicle-card__pay">
              <div className="b-vehicle-card__pay__wrap">
                <div className="b-vehicle-card__pay__now">
                  <div className="b-vehicle-card__pay__prices">
                    <span className="b-vehicle-card__pay__total-price">
                      {dictionary.total}

                      {paymentType === 'nonPrepaid' ? (
                        <SanitizeHtml
                          html={`${nonPrepaidPrice.symbol}&nbsp;${formatNumber(
                            nonPrepaidPrice.total
                          )}`}
                          tag="span"
                        />
                      ) : (
                        <SanitizeHtml
                          html={`${prepaidPrice.symbol}&nbsp;${formatNumber(
                            prepaidPrice.total
                          )}`}
                          tag="span"
                        />
                      )}
                    </span>

                    {payNowSave && (
                      <SanitizeHtml
                        html={`${dictionary.payNowSave} ${prepaidPrice.symbol}&nbsp;${payNowSave}`}
                        tag="span"
                        className="b-vehicle-card__pay__note"
                      />
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={isLoading}
                    onClick={() => handleBooking(paymentType !== 'nonPrepaid')}>
                    {availability === 3
                      ? dictionary.requestBtn
                      : dictionary.bookBtn}
                  </button>
                </div>

                {/* <!-- DEV:render this if you have below data--> */}
                {/* optional sections */}
                {paymentType === 'both' && (
                  <>
                    <div className="b-vehicle-card__separator">
                      <span>{dictionary.or}</span>
                    </div>

                    <div className="b-vehicle-card__pay__later">
                      <div className="b-vehicle-card__pay__prices">
                        <button
                          type="button"
                          className="btn p-0"
                          disabled={isLoading}
                          onClick={() => handleBooking(false)}>
                          <span className="b-vehicle-card__pay__total-price">
                            <SanitizeHtml
                              html={`${
                                nonPrepaidPrice.symbol
                              }&nbsp;${formatNumber(nonPrepaidPrice.total)}`}
                              tag="span"
                            />
                            <span>{dictionary.paidAtPickUp}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {paymentType !== 'both' && grid && (
                  <div className="b-vehicle-card__no-location">
                    {paymentType === 'prepaid'
                      ? dictionary.noPaymentOnLocation
                      : dictionary.noPrepaidAvailable}
                  </div>
                )}
                {/* optional sections end*/}
              </div>
            </div>
          ) : (
            <div className="b-vehicle-card__book">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleBooking}
                title={dictionary.bookBtn}>
                {dictionary.bookBtn}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default VehicleCard
